// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"dropzone_2aNpE","active":"active_3HDwg","message":"message_1LdDu","dragzone":"dragzone_26iAk","draggingPhoto":"draggingPhoto_2vVAc"};


//////////////////
// WEBPACK FOOTER
// ./app/components/dragzone/styles.scss
// module id = 427
// module chunks = 1